export default __webpack_public_path__ + "static/media/Users.b1cc15c6.svg";